var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.444 17.4675H6.55529C5.74485 17.4675 5.08028 16.8354 5.03166 16.025L4.42383 4.73553H15.5836L14.9758 16.025C14.9352 16.8354 14.2626 17.4675 13.4521 17.4675H13.444Z",
    stroke: "#1065D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4195 2.4756H11.5316C11.9125 2.4756 12.2286 2.75115 12.2853 3.12396L12.5284 4.73673H7.45508L7.64958 3.14016C7.69821 2.75926 8.02239 2.4675 8.4114 2.4675L8.4195 2.4756Z",
    stroke: "#1065D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9082 4.74594H17.0909",
    stroke: "#1065D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 7.72662L8.16824 14.5505",
    stroke: "#1065D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 7.72659L11.8311 14.5505",
    stroke: "#1065D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDelete);
export default __webpack_public_path__ + "static/media/i_delete.09e218521ff43ae45ac7596f6a31e463.svg";
export { ForwardRef as ReactComponent };